<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
		<path
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
			d="M7 9h6m-3-3v6m-9 1V3a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2Z"
		/>
	</svg>
</template>
